import { useQuery } from "@tanstack/react-query";
import { aggregateDashboardData } from "../api/dashboardConfig";
import { AggregateRequest } from "../types/dashboard/DashboardConfig";

export const useDashboardAggregate = (
  customerId: string | undefined,
  request: AggregateRequest | null,
  widgetId: string
) => {
  return useQuery({
    queryKey: ["dashboard-aggregate", customerId, widgetId, request],
    queryFn: () => aggregateDashboardData(customerId!, request!),
    enabled: !!customerId && !!request,
  });
};
